/**
 * Vilax Header shadow — Approach A (port to VLT-8).
 *
 * PORT/SHADOW-COUPLING #2: this SHADOWS VLT's internal Header component.
 * VLT-8's Header (src/components/Header/Header.tsx) renders:
 *   <SlotRenderer name="aboveHeader" />
 *   <header className="header-wrapper"><Container layout><InternetHeader/></Container></header>
 *   <SlotRenderer name="belowHeader" />
 * — structurally identical to VLT-7, so the shadow ports verbatim: drop the
 * header-wrapper, keep only the slots, so VilaxHeader (in aboveHeader) is the
 * sole header. BUG-2026-116 rationale unchanged.
 *
 * This is a standing debt: it is a frozen copy of VLT's Header internals and
 * must be re-validated every VLT bump (the file moved .jsx→.tsx and gained the
 * intranet-header branch in VLT-8; we ignore all of it by rendering only slots).
 */
import { useSelector, shallowEqual } from 'react-redux';
import SlotRenderer from '@plone/volto/components/theme/SlotRenderer/SlotRenderer';

const Header = () => {
  const content = useSelector((state) => state.content.data, shallowEqual);
  const navRoot = useSelector(
    (state) => state.navroot?.data?.navroot,
    shallowEqual,
  );

  return (
    <>
      <SlotRenderer name="aboveHeader" content={content} navRoot={navRoot} />
      <SlotRenderer name="belowHeader" content={content} navRoot={navRoot} />
    </>
  );
};

export default Header;
